/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  CpdsRatingsWrapper,
  CpdsRatingsScore,
  CpdsRatingsSummary,
  CpdsRatingsReviewText,
  CpdsRatingsText,
} from './styles/cpds-ratings-style';
import { CpdsRatingsProps } from './typings';

//helpers
import { generateRatingLevels, ratingLevels } from './helpers';
import { themeStyleClass } from '../utils/cpds-utils';
import { checkValue } from 'src/components/common/helper';

const CpdsRatings: React.FC<CpdsRatingsProps> = (props) => {
  const {
    domRef,
    exClasses = '',
    styleOverrides,
    rating,
    ratingText,
    numberOfReviews,
    themeTypography,
    ...rest
  } = props;
  const className = themeStyleClass('cpds-ratings', themeTypography, exClasses);

  const formattedRating = typeof rating === 'string' ? parseFloat(rating) : rating;
  const ratingLevel = generateRatingLevels(formattedRating);

  return (
    <CpdsRatingsWrapper
      className={className}
      ref={domRef}
      styleOverrides={styleOverrides}
      level={ratingLevel.key}
      {...rest}
    >
      <CpdsRatingsScore>{formattedRating.toFixed(1)}</CpdsRatingsScore>
      <CpdsRatingsSummary>
        {ratingLevel?.key !== ratingLevels.okay.key && (
          <CpdsRatingsText>{checkValue(ratingText) ? ratingText : ratingLevel?.text}</CpdsRatingsText>
        )}
        {checkValue(numberOfReviews) && <CpdsRatingsReviewText>{numberOfReviews}</CpdsRatingsReviewText>}
      </CpdsRatingsSummary>
    </CpdsRatingsWrapper>
  );
};

export default CpdsRatings;
